import {useColorScheme} from '@mui/material';
import React, {useEffect} from 'react';
import {Route, Switch} from 'react-router-dom';
import Overview from './pages/Overview.jsx';
import Subscription from './pages/Subscription.jsx';

export default function Routes() {
  const {setMode} = useColorScheme();
  // Force light mode
  useEffect(() => {
    setMode('light');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Switch>
      <Route
        path={[
          '/subscription/:subscriptionId/(.*)',
          '/subscription/:subscriptionId',
        ]}
      >
        <Subscription />
      </Route>
      <Route path="/">
        <Overview />
      </Route>
    </Switch>
  );
}
